<template>
  <CContainer class="pt-5" fluid>
    <Loading :active="isLoading.loadInfo || isLoading.getTableItems"></Loading>
    <CRow>
      <CCol class="col-12">
        <h3 class="pl-3 mb-0 pb-0">Payment</h3>
        <b-breadcrumb class="my-0 pt-1" style="border-bottom: 0px">
          <b-breadcrumb-item to="/invoice-roya">
            <CIcon name="cil-credit-card" />
            Payment Roya
          </b-breadcrumb-item>
          <b-breadcrumb-item active>{{ title }}</b-breadcrumb-item>
          <b-breadcrumb-item active>Detail</b-breadcrumb-item>
        </b-breadcrumb>
      </CCol>
    </CRow>
    <CRow>
      <CCol>
        <b-card no-body>
          <b-tabs card>
            <template #tabs-start v-if="$route.params.invoiceType == 'notary' && !$helper.isEmpty(info.invoiceNoPnbp)">
              <b-nav-item @click="redirectPage()">PNBP</b-nav-item>
            </template>
            <template #tabs-end v-if="$route.params.invoiceType == 'pnbp' && !$helper.isEmpty(info.invoiceNoNotary)">
              <b-nav-item @click="redirectPage()">Notaris</b-nav-item>
            </template>
            <b-tab :title="title">
              
              <CRow class="mb-2">
                <CCol class="col-12 col-md-6 pr-1">
                  <CCard class="custom-form-card custom-card">
                    <CCardBody>
                      <CRow>
                        <CCol class="col-12">
                          <h5 class="custom-header">Data Invoice</h5>
                        </CCol>
                      </CRow>
                      <CRow>
                        <CCol class="pt-2 custom-detail-list">
                          <CRow>
                            <CCol class="col-5 col-xs-5 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                              <p>No. Invoice</p>
                            </CCol>
                            <CCol class="col-7 col-xs-7 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                              <p>: {{ $route.params.invoiceType == 'pnbp' ? info.invoiceNoPnbp : info.invoiceNoNotary }}</p>
                            </CCol>
                            <CCol class="col-5 col-xs-5 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                              <p>No. Receive</p>
                            </CCol>
                            <CCol class="col-7 col-xs-7 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                              <p>: {{ !$helper.isEmpty(info.receiveNo) ? info.receiveNo : '-' }}</p>
                            </CCol>
                            <CCol class="col-5 col-xs-5 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                              <p>Tipe Kontrak</p>
                            </CCol>
                            <CCol class="col-7 col-xs-7 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                              <p>: 
                                <span v-if="info.contractType == 'F'">Fiducia</span>
                                <span v-else-if="info.contractType == 'R'">Roya</span>
                                <span v-else-if="info.contractType == 'A'">APHT</span>
                                <span v-else>-</span>
                              </p>
                            </CCol>
                            <CCol class="col-5 col-xs-5 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                              <p>Business Unit</p>
                            </CCol>
                            <CCol class="col-7 col-xs-7 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                              <p>: {{ !$helper.isEmpty(info.businessUnit) ? info.businessUnit : '-' }}</p>
                            </CCol>
                            <CCol class="col-5 col-xs-5 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                              <p>Status</p>
                            </CCol>
                            <CCol class="col-7 col-xs-7 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                              <p>: 
                                <span v-if="info.paymentStatus == 'U'">UNPAID</span>
                                <span v-else-if="info.paymentStatus == 'P'">PAID</span>
                                <span v-else>-</span>
                              </p>
                            </CCol>
                            <CCol class="col-5 col-xs-5 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                              <p>Total Payment</p>
                            </CCol>
                            <CCol class="col-7 col-xs-7 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                              <p>: Rp {{ !$helper.isEmpty(info.totalPayment) ? Number(info.totalPayment).toLocaleString('id') : '0' }}</p>
                            </CCol>
                            <CCol class="col-5 col-xs-5 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                              <p>Tanggal Pengajuan</p>
                            </CCol>
                            <CCol class="col-7 col-xs-7 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                              <p>: {{ $helper.showData(info.applicationDate, "shortDate") }}</p>
                            </CCol>
                            <CCol class="col-5 col-xs-5 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                              <p>Tanggal Payment</p>
                            </CCol>
                            <CCol class="col-7 col-xs-7 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                              <p>: {{ $helper.showData(info.paymentDate, "shortDate") }}</p>
                            </CCol>
                          </CRow>
                        </CCol>
                      </CRow>
                    </CCardBody>
                  </CCard>
                </CCol>
                <CCol class="col-12 col-md-6 pl-1">
                  <CCard class="custom-form-card custom-card">
                    <CCardBody>
                      <CRow>
                        <CCol class="col-12">
                          <h5 class="custom-header">Data Notaris</h5>
                        </CCol>
                      </CRow>
                      <CRow>
                        <CCol class="pt-2 custom-detail-list">
                          <CRow>
                            <CCol class="col-4 col-xs-4 col-sm-4 col-md-5 col-lg-5 col-xl-3">
                              <p>Nama</p>
                            </CCol>
                            <CCol class="col-8 col-xs-8 col-sm-8 col-md-7 col-lg-7 col-xl-9">
                              <p>: {{ !$helper.isEmpty(info.notaryName) ? info.notaryName : '-' }}</p>
                            </CCol>
                            <CCol class="col-4 col-xs-4 col-sm-4 col-md-5 col-lg-5 col-xl-3">
                              <p>Alamat</p>
                            </CCol>
                            <CCol class="col-8 col-xs-8 col-sm-8 col-md-7 col-lg-7 col-xl-9">
                              <p>: {{ !$helper.isEmpty(info.notaryAddress) ? info.notaryAddress : '-' }}</p>
                            </CCol>
                            <CCol class="col-4 col-xs-4 col-sm-4 col-md-5 col-lg-5 col-xl-3">
                              <p>No. NPWP</p>
                            </CCol>
                            <CCol class="col-8 col-xs-8 col-sm-8 col-md-7 col-lg-7 col-xl-9">
                              <p>: {{ !$helper.isEmpty(info.notaryNpwp) ? info.notaryNpwp : '-' }}</p>
                            </CCol>
                            <CCol class="col-4 col-xs-4 col-sm-4 col-md-5 col-lg-5 col-xl-3">
                              <p>Mobile 1</p>
                            </CCol>
                            <CCol class="col-8 col-xs-8 col-sm-8 col-md-7 col-lg-7 col-xl-9">
                              <p>: {{ !$helper.isEmpty(info.notaryMobile1) ? info.notaryMobile1 : '-' }}</p>
                            </CCol>
                            <CCol class="col-4 col-xs-4 col-sm-4 col-md-5 col-lg-5 col-xl-3">
                              <p>Mobile 2</p>
                            </CCol>
                            <CCol class="col-8 col-xs-8 col-sm-8 col-md-7 col-lg-7 col-xl-9">
                              <p>: {{ !$helper.isEmpty(info.notaryMobile2) ? info.notaryMobile2 : '-' }}</p>
                            </CCol>
                            <CCol class="col-4 col-xs-4 col-sm-4 col-md-5 col-lg-5 col-xl-3">
                              <p>Phone 1</p>
                            </CCol>
                            <CCol class="col-8 col-xs-8 col-sm-8 col-md-7 col-lg-7 col-xl-9">
                              <p>: {{ !$helper.isEmpty(info.notaryTel1) ? info.notaryTel1 : '-' }}</p>
                            </CCol>
                            <CCol class="col-4 col-xs-4 col-sm-4 col-md-5 col-lg-5 col-xl-3">
                              <p>Phone 2</p>
                            </CCol>
                            <CCol class="col-8 col-xs-8 col-sm-8 col-md-7 col-lg-7 col-xl-9">
                              <p>: {{ !$helper.isEmpty(info.notaryTel2) ? info.notaryTel2 : '-' }}</p>
                            </CCol>
                          </CRow>
                        </CCol>
                      </CRow>
                    </CCardBody>
                  </CCard>
                </CCol>
              </CRow>

              <CRow>
                <CCol class="col-12">
                  <CCard class="notes-card">
                    <CCardBody>
                      <div>
                        <strong>Notes:</strong>
                      </div>
                      {{ !$helper.isEmpty(info.notes) ? info.notes : '-' }}
                    </CCardBody>
                  </CCard>
                </CCol>
              </CRow>

              <CRow>
                <CCol>
                  <b-table striped hover show-empty
                    responsive="xl"
                    :items="table.items"
                    :fields="table.fields"
                    :busy="!table.isLoaded"
                    no-local-sorting no-sort-reset
                    @sort-changed="onSortChanged"
                  >
                    <template slot="empty">
                      <div v-if="!table.isLoaded" class="text-center">
                        <b-spinner label="Fetching Data..."></b-spinner>
                      </div> 
                      <div v-else class="text-center">
                        Tidak ada data
                      </div> 
                    </template>
                    <template #cell(contractNo)="row">
                      {{ !$helper.isEmpty(row.value) ? row.value : '-' }}
                    </template>
                    <template #cell(customerName)="row">
                      {{ !$helper.isEmpty(row.value) ? row.value : '-' }}
                    </template>
                    <template #cell(officeName)="row">
                      {{ !$helper.isEmpty(row.value) ? row.value : '-' }}
                    </template>
                    <template #cell(contractDate)="row">
                      {{ $helper.showData(row.value, "shortDate") }}
                    </template>
                    <template #cell(assignmentDate)="row">
                      {{ $helper.showData(row.value, "shortDate") }}
                    </template>
                    <!-- <template #cell(certificateNo)="row">
                      {{ !$helper.isEmpty(row.value) ? row.value : '-' }}
                    </template> -->
                  </b-table>
                  <CCardFooter>
                    <PageSizer :totalRows="table.totalRows" :page="table.currentPage" @page-change="onPageChange" />
                  </CCardFooter>
                </CCol>
              </CRow>

              <CRow class="mt-4" style="text-align: center;">
                <CCol>
                  <CButton class="mr-3" color="primary" @click="downloadDataInvoice" :disabled="isLoading.downloadDataInvoice">
                    <b-spinner small v-if="isLoading.downloadDataInvoice" />
                    {{ isLoading.downloadDataInvoice ? 'Sedang diproses...' : 'Download Excel Invoice' }}
                  </CButton>
                  <CButton color="primary" @click="downloadInvoice" :disabled="isLoading.downloadInvoice">
                    <b-spinner small v-if="isLoading.downloadInvoice" />
                    {{ isLoading.downloadInvoice ? 'Sedang diproses...' : 'Download PDF Invoice' }}
                  </CButton>
                </CCol>
              </CRow>

            </b-tab>
          </b-tabs>
        </b-card>
      </CCol>
    </CRow>
  </CContainer>
</template>


<script>
export default {
  name: 'InvoiceRoyaDetail',
  data() {
    return {
      isLoading: {
        loadInfo: false,
        getTableItems: false,
        downloadDataInvoice: false,
        downloadInvoice: false,
      },

      info: {
        invoiceNoPnbp: '',
        invoiceNoNotary: '',
        contractType: '',
        businessUnit: '',
        paymentStatus: '',
        totalPayment: 0,
        applicationDate: '',
        paymentDate: '',
        receiveNo: '',
        notaryName: '',
        notaryAddress: '',
        notaryNpwp: '',
        notaryTel1: '',
        notaryTel2: '',
        notaryMobile1: '',
        notaryMobile2: ''
      },

      table: {
        isLoaded: false,
        fields: [
          {key: "contractNo", label: "No. Kontrak", sortable: true},
          {key: "customerName", label: "Nama Customer", sortable: true},
          {key: "officeName", label: "Office", sortable: true, class: "custom-column-payment-detail-office"},
          {key: "contractDate", label: "Tanggal Kontrak", sortable: true},
          {key: "assignmentDate", label: "Tanggal Assign", sortable: true},
          // {key: "certificateNo", label: "No. Sertifikat", sortable: true, class: "custom-column-payment-detail-certificate"},
        ],

        items: [],

        sort: {
          by: null,
          desc: false
        },

        currentPage: 1,
        perPage: 10,
        totalRows: 0,
        totalPages: 0
      },

      title: 'Notaris',
    }
  },
  methods: {
    redirectPage() {
      let contractId = this.$route.params.contractId
      let invoiceType = this.$route.params.invoiceType == 'pnbp' ? 'notary' : 'pnbp'
      
      this.$router.push({ name: 'Invoice Roya Detail', params: { invoiceType: invoiceType, contractId: contractId} })
      
      this.title = this.$route.params.invoiceType == 'pnbp' ? 'PNBP' : 'Notaris'
      this.loadInfo()
      this.getTableItems()
    },

    downloadDataInvoice() {
      this.isLoading.downloadDataInvoice = true
      let getUrl = "/excel/getDetailInvoiceByte"

      let params = {
        contractId: this.$route.params.contractId,
        invoiceType: this.$route.params.invoiceType,
        contractType: 'R'
      }

      this.$axios.get(getUrl, {
        // necessary to avoid encoding returned bytes
        params: params, 
        responseType: 'blob',
        timeout: 300000
      }).then(response => {
        if(response.status == 200){
          // create file Blob and download according to extension
          let blob=new Blob([response.data], {type: "application/octet-stream"})
          let link=document.createElement('a')
          link.href=window.URL.createObjectURL(blob)
          if (this.$route.params.invoiceType == 'pnbp') {
            link.download= "Invoice_" + this.$route.params.invoiceType + "_" + this.info.invoiceNoPnbp + "-" + Date.now() + ".xlsx"
          } 
          else{
            link.download= "Invoice_" + this.$route.params.invoiceType + "_" + this.info.invoiceNoNotary + "-" + Date.now() + ".xlsx"
          }
          link.click();
        }
        else{
          this.$helper.toastError(this, "Download Data Invoice Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
        }
      })
      .catch(error => {
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Download Data Invoice Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
        }
        else{
          this.$helper.toastError(this, "Download Data Invoice Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.isLoading.downloadDataInvoice = false
      })
    },

    downloadInvoice() {
      this.isLoading.downloadInvoice = true
      let postUrl = "/payment/createInvoiceByte"
      let data = new FormData()
      if (this.$route.params.invoiceType == 'pnbp') {
        data.set('invoiceNo', this.info.invoiceNoPnbp)
      } else{
        data.set('invoiceNo', this.info.invoiceNoNotary)
      }
      this.$axios.post(postUrl, data, {
          // necessary to avoid encoding returned bytes
          responseType: 'blob',
          timeout: 300000
        }).then(response => {
        if(response.status == 200){
          // create file Blob and download according to extension
          let blob=new Blob([response.data], {type: "application/octet-stream"})
          let link=document.createElement('a')
          link.href=window.URL.createObjectURL(blob)
          if (this.$route.params.invoiceType == 'pnbp') {
            link.download= "Invoice_" + this.info.invoiceNoPnbp + "-" + Date.now() + ".pdf"
          } else{
            link.download= "Invoice_" + this.info.invoiceNoNotary + "-" + Date.now() + ".pdf"
          }
          link.click();
        } 
        else{
          this.$helper.toastError(this, "Download Invoice Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
        }
      })
      .catch(error => {
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Download Invoice Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
        }
        else{
          this.$helper.toastError(this, "Download Invoice Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.isLoading.downloadInvoice = false
      })
    },

    onPageChange(newPage) {
      this.getTableItems(newPage)
    },

    onSortChanged(ctx) {
      this.table.sort.by = ctx.sortBy
      this.table.sort.desc = ctx.sortDesc
      this.getTableItems(this.table.currentPage)
    },

    async loadInfo() {
      this.isLoading.loadInfo = true
      let getUrl = "/payment/getOneInvoiceByNo"
      
      let params = {
        contractId: this.$route.params.contractId,
        invoiceType: this.$route.params.invoiceType,
        contractType: 'R'
      }
      
      return await this.$axios.get(getUrl, {params: params}).then(response => {
        if(response.status == 200){
          this.info = response.data.data
          return true
        } else{
          this.$helper.toastError(this, "Load Informasi Invoice Gagal! " + (response.data.reason ? response.data.reason : ""))
        }
      })
      .catch(error => {
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Load Informasi Invoice Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
        }
        else{
          this.$helper.toastError(this, "Load Informasi Invoice Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.isLoading.loadInfo = false
      })
    },

    getTableItems(page = 1) {
      this.table.isLoaded = false
      this.isLoading.getTableItems = true
      this.table.items = []
      if(isNaN(page)) {
        this.table.currentPage = 1
      }
      else {
        this.table.currentPage = page
      }
      // URL builder
      let getUrl = "/payment/getAllContractByInvoice"

      let params = this.$helper.getBasePagedQuery(this.table.currentPage - 1, this.table.perPage)
      params['invoiceType'] = this.$route.params.invoiceType
      params['contractType'] = this.info.contractType
      if (this.$route.params.invoiceType == 'pnbp') {
        params['invoiceNo'] = this.info.invoiceNoPnbp
      } else{
        params['invoiceNo'] = this.info.invoiceNoNotary
      }
      if(this.table.sort.by != null) {
        params = this.$helper.getBaseSortQuery(this.table.sort, params)
      }

      return this.$axios.get(getUrl, {params: params}).then(response => {
        if(response.status == 200){
          this.table.items = response.data.data.data
          this.table.totalRows = response.data.data.totalElements
          this.table.totalPages = response.data.data.totalPages
        }
        else{
          // this.errorAction(response)
          this.$helper.toastError(this, "Load Daftar Kontrak Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
        }
      })
      .catch(error => {
        // this.errorAction(error)
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Load Daftar Kontrak Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
        }
        else{
          this.$helper.toastError(this, "Load Daftar Kontrak Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.table.isLoaded = true
        this.isLoading.getTableItems = false
      })
    },
  },
  computed: {
  },
  async created(){
    this.title = this.$route.params.invoiceType == 'pnbp' ? 'PNBP' : 'Notaris'
    let success = await this.loadInfo()
    if (success) this.getTableItems()
  }
}
</script>

<style scoped>
.card-header .nav-item a {
  color: white;
}
.card.custom-card {
  min-height: 300px !important;
}
.card.notes-card {
  border-bottom: 5px solid hsl(210, 3%, 85%) !important;
}
thead {
  font-weight: 500;
}
.table-semicolon {
  min-width: 30px; 
  text-align: center;
}
</style>
